import { __awaiter, __generator } from "tslib";
import { JarvisWebHttpClient } from '@jarvis/web-http';
import { Stack } from '../stratus-client';
import apiDiscoveryJson from '../../config/apiDiscovery.json';
var ApiDiscoverySvcClient = /** @class */ (function () {
    function ApiDiscoverySvcClient(baseURL, authProvider) {
        this.apiName = 'ws-hp.com/apidiscoverysvc';
        this.apiVersion = '1';
        this.apisEndpoint = '/apis';
        this.jarvisWebHttpInstance = new JarvisWebHttpClient({
            defaultBaseURL: baseURL,
            defaultAuthProvider: authProvider,
        });
    }
    ApiDiscoverySvcClient.listAPIsSchema = function () {
        return {
            $schema: 'http://json-schema.org/schema#',
            type: 'object',
            required: ['apiList'],
            additionalProperties: true,
            properties: {
                apiList: {
                    type: 'array',
                    items: {
                        type: 'object',
                        required: ['apiName', 'apiHostPrefix', 'apiBasePath', 'apiVersion'],
                        additionalProperties: true,
                        properties: {
                            apiName: {
                                type: 'string',
                            },
                            apiHostPrefix: {
                                type: 'string',
                            },
                            apiBasePath: {
                                type: 'string',
                            },
                            apiVersion: {
                                type: 'string',
                            },
                        },
                    },
                },
            },
        };
    };
    ApiDiscoverySvcClient.prototype.listAPIs = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jarvisWebHttpInstance.get({
                        url: this.apisEndpoint,
                        validationSchema: ApiDiscoverySvcClient.listAPIsSchema(),
                    })];
            });
        });
    };
    return ApiDiscoverySvcClient;
}());
export { ApiDiscoverySvcClient };
var ApiDiscoverySvcCache = /** @class */ (function () {
    function ApiDiscoverySvcCache(stack) {
        this.stack = stack;
    }
    ApiDiscoverySvcCache.getInstance = function (stack) {
        var instance = this.instances.get(stack);
        if (!instance) {
            instance = new ApiDiscoverySvcCache(stack);
            this.instances.set(stack, instance);
        }
        return instance;
    };
    ApiDiscoverySvcCache.prototype.getStackPrefix = function (stack) {
        switch (stack) {
            case Stack.dev:
                return 'dev';
            case Stack.pie:
                return 'pie';
            case Stack.stage:
                return 'stage';
            case Stack.prod:
                return '';
        }
    };
    ApiDiscoverySvcCache.prototype.getAPIIdentifier = function (apiName, apiVersion) {
        return apiName + apiVersion;
    };
    ApiDiscoverySvcCache.prototype.getAPIURL = function (stack, hostPrefix, basePath) {
        var stackPrefix = this.getStackPrefix(stack);
        return ('https://' +
            (hostPrefix.length ? hostPrefix + '.' : '') +
            (stackPrefix.length ? stackPrefix + '-' : '') +
            'us1.api.ws-hp.com' +
            basePath);
    };
    ApiDiscoverySvcCache.prototype.getBaseURL = function (apiName, apiVersion, authProvider, ignoreCache, remoteDiscovery) {
        if (ignoreCache === void 0) { ignoreCache = false; }
        if (remoteDiscovery === void 0) { remoteDiscovery = false; }
        return __awaiter(this, void 0, void 0, function () {
            var response, apiDiscoverySvcURL, apiDiscoverySvcClient, apiDiscoveryResponse, _i, _a, api_1, api;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!this.cache || ignoreCache)) return [3 /*break*/, 3];
                        response = apiDiscoveryJson;
                        if (!remoteDiscovery) return [3 /*break*/, 2];
                        apiDiscoverySvcURL = this.getAPIURL(this.stack, '', '/discovery/v1');
                        apiDiscoverySvcClient = new ApiDiscoverySvcClient(apiDiscoverySvcURL, authProvider);
                        return [4 /*yield*/, apiDiscoverySvcClient.listAPIs()];
                    case 1:
                        apiDiscoveryResponse = (_b.sent()).data;
                        response = apiDiscoveryResponse;
                        _b.label = 2;
                    case 2:
                        this.cache = new Map();
                        for (_i = 0, _a = response.apiList; _i < _a.length; _i++) {
                            api_1 = _a[_i];
                            this.cache.set(this.getAPIIdentifier(api_1.apiName, api_1.apiVersion), this.getAPIURL(this.stack, api_1.apiHostPrefix, api_1.apiBasePath));
                        }
                        _b.label = 3;
                    case 3:
                        api = this.cache.get(this.getAPIIdentifier(apiName, apiVersion));
                        if (!api) {
                            throw new Error("unable to get api with name '".concat(apiName, "' and version '").concat(apiVersion, "'"));
                        }
                        return [2 /*return*/, api];
                }
            });
        });
    };
    ApiDiscoverySvcCache.instances = new Map();
    return ApiDiscoverySvcCache;
}());
export { ApiDiscoverySvcCache };
//# sourceMappingURL=api-discovery-svc.js.map